export enum RecaptchaVersion {
  V2 = 2,
  V3 = 3,
}
